import { render, staticRenderFns } from "./ProcessesMetricsTable.vue?vue&type=template&id=059ed934&scoped=true"
import script from "./ProcessesMetricsTable.ts?vue&type=script&lang=ts&external"
export * from "./ProcessesMetricsTable.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059ed934",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('059ed934')) {
      api.createRecord('059ed934', component.options)
    } else {
      api.reload('059ed934', component.options)
    }
    module.hot.accept("./ProcessesMetricsTable.vue?vue&type=template&id=059ed934&scoped=true", function () {
      api.rerender('059ed934', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Alerts/components/ProcessesTableSection/ProcessesMetricsTable/ProcessesMetricsTable.vue"
export default component.exports